export default {
  10001: "Inserisci il nome utente o l'e-mail",
  10002: 'E-mail inserita in modo errato',
  10003: 'errore di immissione del nome utente',
  10004: 'Password inserita in modo errato',
  10005: 'Stato utente anomalo',
  10006: 'Il nome utente esiste già',
  10007: 'Email già esistente',
  10008: "Lo stato dell'utente è sbagliato",
  10009: 'Nessun utente corrispondente trovato',
  10010: 'Il prodotto Expert Advisor non è corretto',
  10011:
    "Se il saldo dell'utente è insufficiente, ricaricare o sbloccare il deposito prima di effettuare un acquisto.",
  10012: 'Nessun giorno corrispondente trovato',
  10013: "L'importo dell'investimento è sbagliato",
  10014: 'Il prodotto di regolamento quantitativo non è corretto',
  10015: 'Attualmente non disponibile per la negoziazione',
  10016: 'Importo di acquisto errato',
  10017: 'Nessun periodo corrispondente trovato',
  10018: 'Impossibile ottenere i parametri di sistema',
  10019: 'Lo stato di autenticazione corrente di questo utente non è corretto',
  10020: 'Lo stato della raccolta non è corretto',
  10021: 'Indirizzo di ricezione non compilato',
  10022: "L'utente non si è autenticato con il nome reale",
  10023: 'La durata del prestito è impostata in modo errato',
  10024: 'Già acquistato lo stesso prodotto, non acquistarlo nuovamente',
  10025: 'Seleziona un metodo di prelievo',
  10027: "L'importo del prestito non può essere vuoto",
  10028: 'La durata del prestito non può essere vuota',
  10029: "L'importo del prestito deve essere maggiore di 0",
  10030: 'La configurazione della durata del prestito non esiste',
  10031: "L'importo del prestito è inferiore al valore minimo",
  10032: "L'importo del prestito supera il valore massimo",
  10033: "L'ID del record del prestito non può essere vuoto",
  10034: 'Il record del prestito non esiste',
  10035: "Non si dispone dell'autorizzazione per gestire questo record del prestito",
  10036: 'Lo stato del prestito non consente il rimborso',
  10037: 'Saldo del conto insufficiente',
  10108: 'Azioni USA fuori orario di trading (lun–ven 9:30–16:00 ET). Riprovare più tardi.',
  10109: 'Forex/metalli preziosi fuori orario (dom 17:00–ven 17:00 ET). Riprovare più tardi.',
  10110: 'Quantità di trading non valida. Inserire un valore maggiore di 0.',
  20001: 'Invio per la revisione riuscito',
  20002: 'Ricarica aggiunta correttamente e inviata per la revisione',
  20003: 'Prelievo aggiunto correttamente e inviato per la revisione',
  20004: 'Acquisto riuscito',
  20005: 'Modificato con successo',
  20024: 'Hai già acquistato lo stesso prodotto, per favore non acquistarlo di nuovo',
  20102:
    "Il tuo account è stato bloccato. Trading e prelievi sono temporaneamente non disponibili. Contatta l'assistenza per qualsiasi domanda.",
  20103: 'La sessione di accesso è scaduta. Accedi di nuovo.',
  20104: "Non hai effettuato l'accesso. Accedi per continuare.",
  Invite: {
    CopyLink: 'copia link',
    FillInAccount: 'Compila il modulo online e apri un conto di trading',
    Fund: 'fondi',
    FundYourPrefer: 'Finanzia il tuo account tramite il metodo di finanziamento che preferisci',
    InviteFriends: 'Invita gli amici',
    InviteYourFriends: 'Invita i tuoi amici',
    Register: 'Registrati',
    StartTradingPlatform:
      'Inizia a fare trading con la nostra pluripremiata piattaforma di trading',
    Trade: 'commercio',
    WhenYourRewards:
      'Invita i tuoi parenti e amici a unirsi a noi, raccogli insieme generose ricompense e intraprendi la strada verso la ricchezza!',
  },
  Market: {
    CreateAPlanToTrade: 'Crea un piano di trading',
    ETF: 'metalli preziosi',
    ExpectedReturn: 'profitto atteso',
    LastPrice: 'ultimo prezzo',
    Lots: 'mano',
    OpenPrice: 'Prezzo di apertura',
    OrderAgain: 'Ordina di nuovo',
    OrderNumber: "numero d'ordine",
    Price: 'prezzo',
    Prices: 'prezzo',
    Sizes: 'mano...',
    SpotPrice: 'prezzo',
    StopLossPrices: 'Prezzo di stop loss...',
    TakeProfitPrices: 'Prezzo Take Profit...',
    WantMoreStableEarning: 'Vuoi un reddito più stabile',
    WhatIsSmartTrading: 'Cos’è il trading intelligente',
    available: 'Disponibile',
    buy: 'comprare a lungo',
    buyLong: 'comprare/acquistare lungo',
    buyLongBtn: 'comprare a lungo',
    chart: 'grafico',
    checkoutSuccess: 'Liquidazione riuscita',
    close: 'Prezzo di chiusura',
    confirm: 'Confermare',
    contracts: 'contrarre',
    create: 'creare',
    cypto: 'criptovaluta',
    day: 'cielo',
    down: 'autunno',
    estimation: 'profitto atteso',
    forex: 'Forex',
    free: 'Costo della transazione',
    frees: 'Costo della transazione',
    futures: 'Materie prime',
    high: 'il prezzo più alto',
    hour: 'Ora',
    investment: "importo dell'investimento",
    leverage: 'leva',
    limit: 'limite di prezzo',
    low: 'prezzo più basso',
    market: 'prezzo di mercato',
    min: 'minuto',
    mon: 'luna',
    name: 'nome',
    notOpen: 'La funzione non è ancora aperta',
    open: 'prezzo di apertura',
    options: 'Regolamento quantitativo',
    optionsTime: 'Tempo di regolamento',
    orderConfirm: "Conferma dell'ordine",
    requiredMargin: 'Margine richiesto',
    return: 'reddito',
    sell: 'Vendita allo scoperto',
    sellShort: 'vendere/allo scoperto',
    sellShortBtn: 'Vendita allo scoperto',
    stocks: 'azione',
    stopLoss: 'fermare la perdita',
    stopLossPrice: 'Prezzo di stop loss',
    takeProfit: 'Avere un profitto',
    takeProfitPrice: 'Prendi il prezzo di profitto',
    time: 'tempo',
    up: 'salita',
    volume: 'Volume',
    watchlist: 'raccogliere',
    week: 'settimana',
  },
  SmartTrading: {
    InterInvestmentAmount: "importo dell'investimento...",
    SelectATimeframe: 'Scegli un periodo di tempo',
    create: 'creare',
    createAPlan: 'Crea piano',
    dailyYield: 'Reddito giornaliero',
    days: 'cielo',
    investment: 'Quantità',
    investmentRange: 'Limite di finanziamento',
    product: 'Prodotto',
    smrtTrading: 'Commercio intelligente',
    timeframe: 'Periodo di tempo',
  },
  aboutUs: {
    about: 'chi siamo',
    subtitle1: 'Profilo Aziendale',
    subtitle2: 'Compagno',
    title: 'Informazioni su {titolo}',
  },
  account: {
    BTCAmount: 'Quantità',
    LOTS: 'mano',
    LastDigits: 'ultime 6 cifre',
    Lots: 'mano',
    PaymentAmount: 'Importo del pagamento',
    PleaseUploadSubmission:
      'Carica uno screenshot del pagamento in criptovaluta e invialo per la verifica.',
    Preview: 'Anteprima',
    SelectImage: 'Seleziona Immagine',
    Supports: 'Formati supportati: JPG, JPEG2000, PNG',
    TransactionHash: 'hash della transazione',
    UploadProof: 'Carica la prova',
    UploadYourScreenshot: 'Carica uno screenshot del tuo trasferimento',
    accountVerification: "Verifica dell'account",
    address: 'indirizzo',
    allOrders: 'Tutti gli ordini',
    amount: 'Quantità',
    approved: 'Data di approvazione',
    balance: 'Bilancia',
    buy: 'comprare a lungo',
    cancel: 'Annulla',
    changeLanguage: 'Cambia lingua',
    changePassword: 'cambiare la password',
    close: 'Posizione chiusa',
    closePrice: 'Prezzo di chiusura',
    closeTime: 'Orario di chiusura',
    closed: 'Chiuso',
    contactUs: 'Contattaci',
    copyAddress: 'Copia indirizzo',
    copySuccess: 'Copiato con successo',
    cycle: 'ciclo',
    dailyRor: 'Tasso di rendimento giornaliero',
    demo: 'Conto dimostrativo',
    deposit: 'depositare',
    depositWithdraw: 'Depositi e prelievi',
    down: 'autunno',
    downloadPDF: 'Scarica Contratto di prestito',
    earlyExist: 'Termina la transazione',
    earlyExit: 'Termina la transazione',
    earlyExitTip:
      'Se la transazione viene terminata anticipatamente, il sistema dedurrà automaticamente {num} del capitale come risarcimento danni e il tuo reddito totale verrà detratto',
    expandMore: 'Espandi di più',
    expirationTime: 'Data di scadenza',
    failed: 'fallire',
    freeMargin: 'Margine occupato',
    futures: 'contrarre',
    helpCenter: 'problema comune',
    inviteFriends: 'invita gli amici',
    lastPrice: 'ultimo prezzo',
    lever: 'leva',
    liquidatedDamages: 'danni liquidati',
    loan: 'prestito',
    logOut: 'Disconnetti',
    logoutConfirm: 'Sei sicuro di voler uscire?',
    margin: 'profitto atteso',
    myAccount: 'il mio conto',
    notification: 'notificare',
    notifications: 'notificare',
    okay: 'OK',
    open: 'Prezzo di apertura',
    openPrice: 'Prezzo di apertura',
    openTime: 'Orario di apertura',
    options: 'Regolamento quantitativo',
    optionsOrder: 'Ordine di regolamento quantitativo',
    order: 'Ordine',
    pips: 'Punti',
    profit: 'profitto',
    putAway: 'vicino',
    receiveAddress: 'indirizzo di ricezione',
    recreatePlan: 'Continua a creare un piano',
    refund: 'Rimborso',
    refundTip: 'I fondi verranno restituiti al tuo conto in contanti, controlla.',
    repayNow: 'Paga immediatamente',
    repayment: 'rimborso',
    repaymentAmount: 'Importo del rimborso',
    repaymentDate: 'Data di rimborso',
    repeatOrder: 'Continua ad aprire una posizione',
    reviewed: 'Revisione in atto',
    runTime: 'orari di funzionamento',
    save: 'salva',
    sell: 'Vendita allo scoperto',
    settings: 'impostare',
    smart: 'Commercio intelligente',
    startTime: 'Tempo di partenza',
    staticincome: 'Reddito statico',
    status: 'stato',
    success: 'successo',
    time: 'tempo',
    todayEarnings: 'I guadagni di oggi',
    todayProfit: 'Profitto di oggi',
    totalInterest: 'interesse totale',
    totalProfit: 'Profitto totale',
    totalRepayment: 'Rimborso totale',
    totalRevenue: 'Entrate totali',
    transFees: 'Costo della transazione',
    transRecord: 'Registro delle transazioni',
    transaction: 'commercio',
    type: 'tipo',
    up: 'salita',
    withdraw: 'Prelevare denaro',
    withdrawNow: 'Preleva i soldi adesso',
  },
  bangZhuZhongXin: 'Centro assistenza',
  biaoDian: 'punteggiatura',
  board: {
    content: 'Questo software soddisfa tutte le tue esigenze con la migliore competenza tecnica',
    continue: 'Continua',
    skip: 'saltare',
    title: 'La migliore piattaforma di trading',
  },
  bread: {
    introduction: 'introduzione',
  },
  chaKan: 'Controllo',
  chongZhi: 'Riempire',
  chongZhiJinexiaoYuZuiDiChongZhiJinE:
    "L'importo della ricarica è inferiore all'importo minimo della ricarica",
  chongZhiPingZheng: 'Voucher di ricarica',
  chongZhiShiJian: 'Tempo di ricarica',
  chongZhiShuoMing: 'Istruzioni per la ricarica:',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    "Istruzioni di deposito: l'importo del deposito minimo per USDT è 120, l'importo del deposito minimo per BTC è 0,015 e l'importo del deposito minimo per ETH è 0,2",
  close: 'Chiudi',
  'customerService.error':
    "L'assistenza clienti è temporaneamente non disponibile. Riprova più tardi.",
  'customerService.close': 'Chiudi',
  'customerService.connected': 'Connesso',
  'customerService.imageAlt': 'Immagine dell’assistenza',
  'customerService.imagePreview': 'Anteprima immagine',
  'customerService.imageTooLarge': 'L’immagine non può superare 5 MB',
  'customerService.imageTypeUnsupported': 'Sono supportate solo immagini PNG, JPEG o WebP',
  'customerService.imageUnavailable': 'Immagine non disponibile',
  'customerService.loadFailed':
    "Impossibile caricare l'assistenza clienti online. Riprova più tardi.",
  'customerService.loading': 'Caricamento…',
  'customerService.loginRequired': 'Accedi per contattare il supporto',
  'customerService.openImage': 'Apri immagine',
  'customerService.placeholder': 'Scrivi un messaggio, premi Invio per inviare',
  'customerService.send': 'Invia',
  'customerService.sendImage': 'Invia immagine',
  'customerService.reconnecting': 'Riconnessione in corso',
  'customerService.title': 'Supporto',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    'La maggior parte dei siti Web adotta misure per proteggere le informazioni personali degli utenti, ad esempio utilizzando la tecnologia di crittografia per proteggere le password.',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    "La maggior parte dei siti Web consente agli utenti di modificare le proprie informazioni personali, ad esempio modificando l'indirizzo e-mail o la password. \nTuttavia, alcune informazioni potrebbero non essere modificate, come il nome utente.",
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    'Non sono richiesti interessi entro {num} giorni dalla presa del prestito e gli interessi verranno pagati dopo {num} giorni.',
  daiShenHe: 'Revisione in atto',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    "Tuttavia, se il sito Web o l'applicazione che utilizzi presenta una vulnerabilità di sicurezza, le tue informazioni personali potrebbero essere esposte.",
  dangQiLiRun: 'Utile per il periodo corrente',
  dangQianLiXi: 'interesse attuale',
  daoQiHuanXiHuanBen: 'Rimborsare interessi e capitale alla scadenza',
  daoQiShiJian: 'Data di scadenza',
  dengLuChengGong: 'accesso riuscito',
  di: 'Basso',
  dianHuaHaoMa: 'numero di telefono:',
  dieJiaLiShuai: 'Tasso di interesse sovrapposto:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: 'alto',
  gouMai: 'Acquistare',
  gouMaiChengGong: 'Acquisto riuscito',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    "I conti in valuta internazionale contattano i servizi di supporto online per l'abbinamento",
  home: {
    Application: 'applicazione',
    AvailableOnThe: 'Disponibile su',
    CreditCard: 'crittografia',
    CreditCardInfo:
      'Utilizzando la criptovaluta per i depositi, ottieni un ulteriore livello di sicurezza e garantisci una rapida elaborazione delle transazioni.',
    CryptocurrenciesListed: 'Criptovalute quotate',
    GetStarted: 'inizio',
    NewFeaturesInOnline: 'Nuove funzionalità on-line',
    NewFeaturesInOnlineInfo: 'Scopri le interessanti funzionalità di questa piattaforma completa',
    RegisteredUsers: 'utente registrato',
    allChains: 'All Chains',
    announcementClose: 'Chiudi avviso',
    announcementLabel: 'Avviso',
    announcementView: 'Vedi dettagli',
    announcementAmount: 'Importo prestato',
    announcementAnnualRate: 'Rendimento annuo',
    announcementBelowMinimum: 'Meno di {amount} USDT',
    announcementCompoundInterest: 'Interesse composto',
    announcementCurrentConfig: 'Configurazione attuale',
    announcementEarningMode: 'Metodo di interesse',
    announcementRateNotice:
      'I rendimenti seguono le fasce attuali della piattaforma. Gli importi definitivi sono indicati nella pagina Attività e nei registri di regolamento.',
    announcementRatesLoading: 'Caricamento delle fasce di rendimento…',
    announcementSettlement: 'Orari di regolamento giornalieri',
    announcementSimpleInterest: 'Interesse semplice',
    announcementYieldEyebrow: 'Informazioni sul rendimento',
    announcementYieldIntro:
      'Importi prestati maggiori ricevono rendimenti annui più elevati. Gli importi sotto la prima fascia possono partecipare ma non maturano interessi.',
    announcementYieldTitle: 'Dettagli del rendimento attuale',
    appLicationInfo:
      'Il mobile banking che abbandona le regole tradizionali per fornirti strumenti precisi di gestione finanziaria.',
    billion: 'B',
    billionInfo: 'Volume medio degli scambi nelle 24 ore',
    button1Title: 'Commissioni di transazione minime',
    button1Title1: 'Fai trading su tutti i tuoi asset in un unico posto',
    button1Title2: 'Forex, criptovalute, azioni, ETF, futures',
    button2Title: 'Tassi di interesse bassi e limiti più alti',
    button2Title1: 'prestiti per investimenti',
    button2Title2:
      "Non è richiesta alcuna garanzia, prendi in prestito facilmente e goditi l'opportunità di apprezzamento della ricchezza!",
    button3Title: 'Semplice e stabile',
    button3Title1: 'Commercio intelligente',
    button3Title2: 'Crea il tuo piano di profitto in un clic',
    button4Title: 'Aiutare i bambini di tutto il mondo',
    button4Title1: 'Beneficenza NFT',
    button4Title2: "Acquista arte NFT per sostenere l'UNICEF",
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: 'Fornisci liquidità al pool di prestito per guadagnare interessi',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: 'Acquista, scambia e mantieni oltre 350 criptovalute sulla migliore piattaforma.',
    loading: 'Loading...',
    million: 'M',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: 'Il portafoglio può scambiare BTC con USD',
    noticeInfo1: 'Opera con un conto demo',
    periodDays: '{count} day | {count} days',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
  },
  huanKuanZhong: 'Rimborso in corso',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    'Benvenuto nella nostra pluripremiata piattaforma di trading finanziario ed esplora il futuro mondo finanziario con investitori globali!',
  jiXiShiJian: 'Tempo di maturazione degli interessi',
  jiXuTouZi: 'Continua a investire',
  jiangTuPianTuoFangDaoCiChuHuo: "Trascina e rilascia un'immagine qui, oppure",
  jieZhiShiJian: 'scadenza',
  jiuMiMa: 'vecchia password',
  juJueYuanYin: 'Motivo del rifiuto',
  kai: 'aprire',
  lendingAssets: {
    authorizedBalance: 'Saldo autorizzato',
    availableAmount: 'Disponibile al prelievo',
    dailyOrders: 'Ordini di regolamento giornalieri',
    dailyProfit: 'Profitto giornaliero',
    joinPool: 'Entra nel pool',
    loadMore: 'Carica altro',
    needAuth: 'Entra in un lending pool per vedere saldi e guadagni',
    needLogin: 'Accedi per visualizzare i tuoi asset',
    noOrders: 'Nessun ordine di regolamento',
    pageDesc: 'Visualizza saldi autorizzati, guadagni del pool e ordini di regolamento giornalieri',
    poolEarnings: 'Guadagni del lending pool',
    todayEarnings: 'Oggi',
    totalEarnings: 'Guadagni totali',
    withdraw: 'Prelievo',
    withdrawRecords: 'Cronologia prelievi',
    withdrawnAmount: 'Gia prelevato',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      "<p><strong>Versione documento:</strong> V3.28 &nbsp;|&nbsp; <strong>Data di pubblicazione:</strong> 2022 &nbsp;|&nbsp; <strong>Tipo:</strong> Whitepaper prodotto e riepilogo valutazione sicurezza</p>\n\n<h2>1. Sommario esecutivo</h2>\n<p>Questo modulo Lending Pool è un servizio di prestito e liquidità on-chain basato su protocolli DeFi di mercato monetario. Tramite smart contract open source e modelli di tasso programmabili, il sistema collega gli asset digitali degli utenti ai mercati di prestito on-chain consolidati, abilitando <strong>rendimenti su depositi, prestiti garantiti e liquidità condivisa</strong>.</p>\n<p>Il modulo non richiede intervento manuale per l'allocazione quotidiana dei fondi. Tassi, capacità e utilizzo sono determinati in tempo reale dai mercati on-chain e mostrati in modo trasparente tramite aggregazione dati multi-fonte.</p>\n\n<h2>2. Contesto di settore e posizionamento</h2>\n<p>Il credito tradizionale dipende da istituzioni centralizzate. I protocolli DeFi utilizzano smart contract per abbinare automaticamente domanda e offerta, con sovracollateralizzazione e meccanismi di liquidazione.</p>\n<p>Posizionamento di questo modulo:</p>\n<ul>\n  <li><strong>Gateway ai mercati monetari on-chain:</strong> aggrega dati di pool su più chain e protocolli;</li>\n  <li><strong>Distribuzione programmatica dei rendimenti:</strong> regolamento automatico su base fissa in base ai saldi autorizzati e all'APY di mercato;</li>\n  <li><strong>Trasparente e verificabile:</strong> TVL, APY, utilizzo e LTV tracciabili su dati on-chain pubblici;</li>\n  <li><strong>Non custodial:</strong> autorizzazione e interazioni on-chain avviate dal wallet dell'utente.</li>\n</ul>\n\n<h2>3. Architettura di sistema</h2>\n<h3>3.1 Panoramica</h3>\n<ul>\n  <li><strong>Interfaccia utente:</strong> connessione wallet, autorizzazione, navigazione pool, consultazione guadagni;</li>\n  <li><strong>Layer di servizio:</strong> autenticazione, gestione autorizzazioni, ordini di rendimento, contenuti multilingua;</li>\n  <li><strong>Layer di aggregazione dati:</strong> sincronizzazione programmata da fonti DeFi pubbliche;</li>\n  <li><strong>Layer protocollo on-chain:</strong> smart contract di prestito auditati eseguono depositi e prestiti.</li>\n</ul>\n\n<h3>3.2 Metriche chiave</h3>\n<table>\n  <thead>\n    <tr><th>Metrica</th><th>Descrizione</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>Asset totali del pool in USD</td></tr>\n    <tr><td>Supply APY</td><td>Rendimento annuo depositi (tasso base + ricompense)</td></tr>\n    <tr><td>Borrow APY</td><td>Costo annuo pagato dai mutuatari</td></tr>\n    <tr><td>Tasso di utilizzo</td><td>Rapporto fondi presi in prestito su fondi disponibili</td></tr>\n    <tr><td>Max LTV</td><td>Rapporto prestito/valore massimo prima della liquidazione</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>Limiti per asset per controllare il rischio di concentrazione</td></tr>\n    <tr><td>Liquidità disponibile</td><td>Liquidità immediatamente prelevabile</td></tr>\n  </tbody>\n</table>\n\n<h2>4. Flusso utente e meccanismo di rendimento</h2>\n<ol>\n  <li><strong>Connetti il wallet</strong> via Web3;</li>\n  <li><strong>Autorizza gli asset</strong> (USDT, USDC, ecc.) con Approve on-chain;</li>\n  <li><strong>Entra nel lending pool</strong> per la coda di calcolo dei rendimenti;</li>\n  <li><strong>Regolamento rendimenti</strong> giornaliero in base al saldo autorizzato e ai tassi di mercato;</li>\n  <li><strong>Consulta gli asset</strong> in «Il mio portafoglio».</li>\n</ol>\n<p><strong>L'APY storico non garantisce rendimenti futuri.</strong></p>\n\n<h3>4.3 Commissioni</h3>\n<h4>Come vengono addebitate le commissioni DeFi Earn?</h4>\n<p>Le transazioni on-chain richiedono commissioni gas per interagire con gli smart contract, inclusi sottoscrizione e riscossione dei rendimenti. Per alcuni asset, il lending pool DeFi e i gestori del vault possono addebitare una commissione di performance come percentuale del profitto effettivo; il capitale non è interessato.</p>\n\n<h2>5. Progettazione della sicurezza</h2>\n<ul>\n  <li>Protocolli sottostanti con contratti open source auditati;</li>\n  <li>Architettura non custodial; nessuna chiave privata memorizzata;</li>\n  <li>Permessi Token Approve minimi; revocabili in qualsiasi momento;</li>\n  <li>Auth token, HTTPS, RBAC admin e audit trail operativi.</li>\n</ul>\n\n<h2>6. Riepilogo valutazione sicurezza</h2>\n<table>\n  <thead>\n    <tr><th>Voce</th><th>Esito</th><th>Note</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>Dipendenze smart contract</td><td><strong>Superato</strong></td><td>Protocolli DeFi auditati pubblicamente</td></tr>\n    <tr><td>Non custodial e gestione chiavi</td><td><strong>Superato</strong></td><td>Nessun storage di chiavi private</td></tr>\n    <tr><td>API e autenticazione</td><td><strong>Superato</strong></td><td>Auth token e HTTPS attivi</td></tr>\n    <tr><td>Sincronizzazione dati</td><td><strong>Superato</strong></td><td>Sync programmata con snapshot</td></tr>\n    <tr><td>Logica regolamento rendimenti</td><td><strong>Superato</strong></td><td>Regole esplicite; ordini verificabili</td></tr>\n  </tbody>\n</table>\n\n<h2>7. Informativa sui rischi</h2>\n<ul>\n  <li><strong>Rischio smart contract:</strong> possibili vulnerabilità non scoperte;</li>\n  <li><strong>Rischio di mercato:</strong> l'APY può variare significativamente;</li>\n  <li><strong>Rischio di liquidazione:</strong> calo del collaterale può attivare la liquidazione;</li>\n  <li><strong>Rischio de-peg stablecoin:</strong> USDT/USDC possono deviare da $1,00;</li>\n  <li><strong>Rischio normativo:</strong> la regolamentazione DeFi è in evoluzione.</li>\n</ul>\n<p><strong>Questo modulo non fornisce consulenza d'investimento e non garantisce rendimenti fissi.</strong></p>\n\n<h2>8. Glossario</h2>\n<ul>\n  <li><strong>APY:</strong> rendimento percentuale annuo;</li>\n  <li><strong>TVL:</strong> valore totale bloccato;</li>\n  <li><strong>LTV:</strong> rapporto prestito/valore;</li>\n  <li><strong>Approve:</strong> autorizzazione token ERC-20;</li>\n  <li><strong>Liquidazione:</strong> vendita automatica del collaterale in caso di sottocollateralizzazione.</li>\n</ul>\n\n<p>— Solo a scopo informativo. Non costituisce consulenza legale, finanziaria o d'investimento. Verificare i dati on-chain tramite block explorer e interfacce ufficiali dei protocolli.</p>",
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: "Accedi prima di effettuare la verifica dell'identità",
    needVerifyHint: "Completa la verifica dell'identità prima di unirti al lending pool",
    pageDesc: "Completa la verifica dell'identità per unirti al lending pool",
    pendingHint: "La verifica dell'identità è in revisione. Attendi pazientemente",
  },
  lendingMenu: {
    assets: 'Asset',
    chooseDepositAsset: 'Scegli un asset da depositare',
    chooseDepositHint:
      'Deposita asset in un lending pool per ottenere rendimento e abilitare i prestiti',
    copyUid: 'Copia UID',
    customerService: 'Customer Service',
    depositAssetAction: 'Deposita {symbol}',
    earnings: 'Come guadagnare',
    empty: 'Nessun contenuto',
    explore: 'Esplora',
    footerDesc:
      'Un mercato monetario on-chain di nuova generazione costruito su smart contract open source. Regole programmatiche sostituiscono il controllo manuale, offrendo agli utenti Web3 di tutto il mondo servizi sicuri e trasparenti di deposito e prestito di liquidità.',
    getStarted: 'Unisciti ora',
    home: 'Home',
    identityVerification: 'Verifica identità',
    intro: 'Informazioni',
    language: 'Lingua',
    noAssetPool: 'Nessun lending pool trovato per questo asset',
    rulesSecurity: 'Rules & Security',
    security: 'Sicurezza',
    theme: 'Aspetto',
    uid: 'UID',
    whitepaper: 'Whitepaper',
    yieldLadder: 'Livelli di rendimento',
  },
  lendingTheme: {
    auto: 'Sistema',
    dark: 'Scuro',
    light: 'Chiaro',
    title: 'Aspetto',
  },
  lendingYieldLadder: {
    balance: 'Capitale del singolo prestito (USDT)',
    compoundInterest: 'Interesse composto',
    earningMode: 'Modalità di rendimento: {mode}',
    empty: 'Nessun livello configurato',
    loading: 'Caricamento dei tassi per livello…',
    noteFixed: 'Regolamento giornaliero al tasso fisso del livello',
    noteRange: "Regolamento giornaliero al limite superiore dell'intervallo",
    notes: 'Note',
    rate: 'Intervallo del rendimento giornaliero',
    settlementHours: 'Orari di regolamento configurati: {hours}',
    simpleInterest: 'Interesse semplice',
  },
  liangCiMiMaBuYiZhi: 'Due password non sono coerenti',
  loan: {
    Browse: 'Navigare',
    address: 'indirizzo:',
    birthdate: 'data di nascita:',
    borrow: 'prestito',
    borrowNow: 'Prendi in prestito adesso',
    borrowPlaceholder: 'Voglio prendere in prestito...',
    browse: 'Navigare',
    checkIn: 'Invio completato',
    confirm: 'Confermare',
    continue: 'Continua',
    country: 'nazione:',
    dailyRate: 'tasso di interesse giornaliero',
    days: 'cielo',
    document: 'Documenti:',
    done: 'Fine!',
    driverLicense: 'patente di guida',
    dropHere: "Trascina e rilascia l'immagine qui",
    ensure: 'Sicuro',
    female: 'femmina',
    firstName: 'nome:',
    idCard: "carta d'identità",
    inHand: 'Fare foto',
    lastName: 'Cognome:',
    launchCamera: 'Avvia la fotocamera',
    loanAgreement: 'contratto di prestito',
    loanAmount: 'ammontare del prestito',
    loanDetail: 'dettagli del prestito',
    loanTerm: 'durata del prestito',
    male: 'maschio',
    notVerifyBtn: 'Avvia la verifica',
    notVerifyTip: 'Verifica la tua identità e ottieni più limiti di prestito!',
    or: 'O',
    passport: 'passaporto',
    pendingReview: 'in corso di revisione',
    phone: 'numero di telefono:',
    phonePlaceholder: 'Inserisci il tuo numero di telefono...',
    reSign: 'dimettersi',
    resubmit: 'Invia di nuovo',
    sex: 'Femmina maschio:',
    sign: 'cartello',
    signTip: 'Per favore conferma e firma',
    signed: 'firmato',
    startVerfication: 'Avvia la verifica',
    submit: 'invia',
    supports: 'Supporto: JPG, JPEG2000, PNG',
    takePhoto: 'Fotografia',
    term: 'Durata del prestito (giorni)',
    tipIdCardBack: "Posiziona il retro della carta d'identità nella cornice",
    tipIdCardFront: "Posiziona la parte anteriore della carta d'identità nella cornice",
    tipNotPass:
      'Siamo spiacenti, la tua richiesta KYC non ha superato il processo di verifica. \nSi prega di inviare nuovamente i materiali di richiesta corretti per completare la verifica KYC. \nSe hai domande o hai bisogno di assistenza, non esitare a contattare il nostro team di assistenza clienti.',
    tipTakePhoto: 'Per favore tieni il tuo',
    tipVerifiedSuccess:
      'Congratulazioni! \nLa tua richiesta KYC è stata verificata e ora puoi usufruire di un livello di servizio più elevato.',
    tipWaitForResult:
      'Grazie per aver inviato le informazioni sulla certificazione KYC. \nIl nostro team esaminerà le tue informazioni entro 48 ore, sii paziente!',
    title: 'prestito',
    totalAmount: 'importo totale degli interessi',
    verifiedSuccessfully: 'Verifica riuscita',
    verifiedUnsuccessfully: 'verifica fallita',
    verifyBtn: 'Verifica riuscita',
    verifyTip: 'Ottieni fondi immediati per proteggere il tuo investimento!',
  },
  login: {
    btnContinueFacebook: 'Continua a utilizzare Facebook',
    btnContinueGoogle: 'Continua a utilizzare Google',
    btnLogin: 'Login',
    btnLoginFacebook: 'Fai il login con facebook',
    btnLoginGoogle: 'Accedi con Google',
    btnNext: 'Passo successivo',
    btnRecovery: 'recuperare',
    btnRecoveryPsd: 'Recupera password',
    btnRegister: 'Registrati',
    btnRegisterFacebook: 'Iscriviti con Facebook',
    btnRegisterGoogle: 'Registrati utilizzando Google',
    btnSend: 'Inviare',
    btnSignup: "Registrati utilizzando l'e-mail",
    email: 'Email',
    emailPlaceholder: "Inserisci l'email, es. name@example.com",
    emailTips: 'Questa email è già registrata.',
    hasAccount: 'Hai già un account?',
    hasNotAccount: 'Non hai ancora un conto?',
    inputCode: 'Per favore inserisci il codice',
    inputEmail: "Per favore inserisci l'email",
    inputPassword: 'Per favore inserisci la password',
    inputPhone: "Per favore inserisci l'email",
    inputUsernameOrEmail: 'Inserisci nome utente o email',
    labelEmail: 'Posta:',
    labelEmailCode: 'Codice di verifica:',
    labelPsd: "parola d'ordine:",
    labelPsdNew: 'Nuova password:',
    labelPsdRepeat: 'Conferma password:',
    labelUsername: 'nome utente:',
    labelUsernameOrEmail: 'Nome utente o email:',
    phone: 'Posta:',
    phoneTips: 'Questo indirizzo email è stato registrato',
    starLogin: 'Iniziamo con il login!',
    starRegist: 'Iniziamo con la registrazione!',
    starReset: 'Recupera la password via email!',
    tipRegisterContent:
      'Completa la tua registrazione e apri le porte a un entusiasmante mondo di opportunità di investimento, aprendo la strada al successo e alla crescita finanziaria!',
    tipRegisterTitle: 'Iscriviti e inizia il tuo prospero viaggio di investimento!',
    useEmailRegister: 'Registrati con email',
    usePhoneRegister: 'Registrati con numero di telefono',
    username: 'nome utente',
    usernameOptional: 'Nome utente (opzionale; vuoto = email)',
    usernameTips: 'Questo nome utente esiste già!',
    welcome: 'Benvenuto a',
  },
  navBottom: {
    bottomCompany: 'azienda',
    bottomCompanyItem1: 'chi siamo',
    bottomCompanyItem2: 'Supervisione delle licenze',
    bottomCompanyItem3: 'problema comune',
    bottomCompanyItem4: 'Supporto online',
    bottomOther: 'dichiarazione',
    bottomOtherItem1: 'informazione legale',
    bottomOtherItem2: 'Disclaimer',
    bottomOtherItem3: 'avviso di rischio',
    bottomOtherItem4: 'Gestione dei Cookie',
    bottomOtherItem5: 'A proposito di pubblicità',
    bottomPolicy: 'politica',
    bottomPolicyItem1: 'Termini e Condizioni',
    bottomPolicyItem2: 'politica sulla riservatezza',
    bottomProduct: 'Prodotto',
    bottomProductItem1: 'Elenco dei mercati',
    bottomProductItem2: 'prestito per investimenti',
    bottomProductItem3: 'NFT sul welfare pubblico',
    bottomProductItem4: 'Commercio intelligente',
  },
  navTab: {
    btnLogin: 'Login',
    btnSignup: 'Registrati',
    language: 'lingua',
    languageTips: 'Seleziona la lingua e la regione',
    tabMenu1: 'prima pagina',
    tabMenu2: 'mercato',
    tabMenu3: 'Commercio intelligente',
    tabMenu4: 'prestito',
    tabMenu5: 'NFT',
    tabMenu6: 'Account',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: 'Il prezzo di stop loss inserito non è ragionevole',
  ninShuRuDeZhiYingJiaGeBuHeLi: 'Il prezzo take profit inserito non è ragionevole',
  ntfs: {
    Address: 'indirizzo',
    AllMoneyCharities:
      "Tutti i proventi della vendita degli NFT saranno devoluti a enti di beneficenza dell'UNICEF",
    BuyNFT: 'Acquista arte NFT e aiuta i bambini di tutto il mondo!',
    BuyNow: 'Compralo Subito',
    Chain: 'Catena di appartenenza',
    Confirm: 'Confermare',
    Creator: 'Creatore',
    CumulativeDonation: 'Donazioni accumulate',
    CurrentBid: 'offerta corrente',
    Markets: 'mercato',
    MyNFTs: 'I miei NFT',
    NFTs: 'NFT',
    NFTsDetail: 'Dettagli NFT',
    PlaceABid: 'Offerta',
    RemainingTime: 'tempo rimasto',
    Successful: 'successo',
    ThanksDonation: 'Grazie per la vostra donazione',
    Thisaddress: "L'articolo verrà inviato all'indirizzo del tuo portafoglio",
    Verified: 'Verificato',
    andUNICEF: "Le donazioni saranno devolute all'UNICEF",
    charity: 'caritatevole',
  },
  null: 'errore sconosciuto',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: 'Passa al funzionamento del conto reale',
  qingShangChuanPingZheng: 'Si prega di caricare il certificato',
  qingShuRuDiZhi: "Inserisci l'indirizzo",
  qingShuRuShouJiHao: 'per favore inserisci la tua email',
  qingShuRuTouZiJinE: "Inserisci l'importo dell'investimento",
  qingShuRuYanZhengMa: 'inserisci il codice di verifica',
  qingShuRuZhengQueDeJinE: "Inserisci l'importo corretto",
  qingShuRuZhengQueDeYouXiang: 'per favore inserisci la tua email valida',
  qingShuRuZhiSunJiaGe: 'Inserisci il prezzo dello stop loss',
  qingShuRuZhiYingJiaGe: 'Inserisci il prezzo take profit',
  qingTianXieWanZhengXinXi: 'Si prega di compilare le informazioni complete',
  qingZaiCiShuRuMiMa: 'Inserisci nuovamente la password',
  queRenMiMa: 'Conferma password',
  repaySuccess: 'Rimborso riuscito',
  ri: 'giorno',
  riLiShuai: 'Tasso di interesse giornaliero:',
  search: {
    SearchHere: 'ricerca',
  },
  shangChuanShiBaiQingZhongShi: 'Caricamento non riuscito, riprova',
  shenHeBuTongGuo: 'Audit non superato',
  shou: 'ricevere',
  shouJiHao: 'Posta',
  shouXuFeiShiJiDaoZhangJinE: 'Commissione di gestione/importo effettivo ricevuto',
  shouYiZhong: 'Reddito',
  shouYiZhuangTai: 'stato reddituale',
  shuRuNinDeDianHuaHaoMa: 'Inserisci il tuo numero di telefono...',
  souSuo: 'ricerca...',
  tiJiaoChengGong: 'Inserito con successo',
  tiJiaoChongZhiPingZheng: 'Invia voucher di ricarica',
  tiKuanFangShi: 'Metodo di prelievo',
  tiXian: 'ritirare',
  tiXianDiZhi: 'Indirizzo di ritiro',
  tiXianShiJian: 'Tempo di ritiro',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    'Il prelievo richiede una commissione di gestione del {rate}%, che richiede la conferma da parte del nodo di rete prima di poter essere depositato sul conto. Si prega di non trasferire criptovaluta a estranei.',
  toast: {
    UnreasonablePriceProfitLoss:
      'Le impostazioni dei prezzi take profit e stop loss sono irragionevoli',
    buyNumbers: 'Inserisci la quantità di acquisto',
    copyError: 'Copia fallita!',
    copySuccess: 'Copia con successo!',
    email: 'Per favore inserisci la tua email',
    inputAll: 'Inserimento dati incompleto',
    logOut: 'Disconnesso',
    noData: 'niente più dati',
    notAddress: "Inserisci l'indirizzo del portafoglio",
    notAmount: "Inserisci l'importo",
    notEmail: "Il formato dell'e-mail non è corretto",
    notImage: "Il formato dell'immagine non è corretto",
    notLoanAmount: "Inserisci l'importo del prestito",
    notSigned: 'non firmato',
    notSmartAmount: "Inserisci l'importo finanziario",
    notSupportMedia: "L'ottenimento di contenuti multimediali utente non è supportato",
    notVerify: 'Completa prima la verifica KYC',
    notWithdrawAmount: "Inserisci l'importo del prelievo",
    nothingfound: 'Nessun contenuto ancora trovato!',
    password: 'Per favore, inserisci la password',
    passwordNotSame: "L'immissione della password non è coerente",
    passwordRepeat: 'Per favore conferma la tua password',
    uploadImage: 'Si prega di caricare le immagini richieste',
    userName: 'per favore inserisci il nome utente',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    'Di solito sono richieste informazioni di base come e-mail, nome utente, password e talvolta informazioni personali e informazioni di contatto.',
  touZiShiJian: 'tempo di investimento',
  touZiZhouQi: 'ciclo di investimenti',
  tuPianDaXiaoBuNengChaoGuo_2mb: "La dimensione dell'immagine non può superare i 2 MB!",
  tuPianDaXiaoBuNengChaoGuo_5m: "La dimensione dell'immagine non può superare i 50 MB!",
  uploadfailed: 'caricamento fallito',
  usdtZuiDiChongZhiJinewei_120: "L'importo minimo del deposito di {name} è {limit}",
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    "La quantificazione del trading automatico Forex è un metodo che utilizza programmi informatici e algoritmi per eseguire automaticamente strategie di trading. \nQuesto metodo utilizza dati storici, indicatori tecnici, modelli statistici e altri strumenti analitici per identificare segnali di trading ed eseguire automaticamente questi segnali durante l'esecuzione delle operazioni. \nLa quantificazione del trading automatizzato Forex può aiutare i trader a eliminare l'impatto delle emozioni, ridurre le transazioni errate e migliorare l'efficienza e la coerenza delle transazioni. \nTuttavia, la quantificazione automatizzata del trading FX presenta anche alcuni rischi e limiti potenziali. \nAd esempio, i programmi di trading automatizzati potrebbero non essere in grado di adattarsi ai cambiamenti del mercato e la qualità e l’efficacia dei programmi e degli algoritmi di trading dipendono in gran parte dall’affidabilità e dalla validità dei dati storici. \nInoltre, il trading automatico può comportare anche rischi tecnici, come guasti del computer, interruzione della rete, ecc. Pertanto, prima di utilizzare la quantificazione automatizzata del trading in valuta estera, gli investitori devono valutare attentamente i propri obiettivi di trading, la tolleranza al rischio e le capacità tecniche e scegliere un fornitore affidabile. piattaforma di scambio. \nPiattaforme di trading e programmi di trading automatizzati. \nAncora più importante, gli investitori dovrebbero sempre prestare attenzione e adottare misure adeguate di gestione del rischio per proteggere i propri investimenti.",
  wallet: {
    activate: 'Attiva',
    authFailed: 'Autorizzazione fallita',
    authSuccess: 'Autorizzazione riuscita',
    authorized: 'Autorizzato',
    connectFailed: 'Connessione al portafoglio fallita',
    connectWallet: 'Connetti portafoglio',
    connecting: 'Connessione in corso...',
    justCanWallet: 'Questo sito web accetta accesso solo da Dapp decentralizzate',
    networkNotSupported: 'La rete attuale non è supportata, per favore passa a una rete supportata',
    noWalletDetected: 'Nessun portafoglio rilevato. Si prega di installare MetaMask o TronLink.',
    pleaseConnectWallet: 'Per favore, connetti il tuo portafoglio',
    status: 'Stato del portafoglio',
    testnetDisabled: 'La testnet è disabilitata, usa la mainnet',
    transactionCancelled: 'Transazione annullata',
    unauthorized: 'Non autorizzato',
    userCancelled: "Operazione annullata dall'utente",
  },
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    "Timeout della rete, vai all'elenco degli ordini per visualizzare l'ordine",
  weiKaiQiZhiNengJiaoYi: 'Il trading intelligente non è abilitato',
  weiRenZheng: 'non certificato',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: 'Perché devo registrare un account?',
  weiTongGuo: 'Non è passato',
  woDeZhuCeXinXiHuiBeiBaoMiMa: 'Le mie informazioni di registrazione saranno mantenute riservate?',
  woKeYiGengGaiWoDeZhuCeXinXiMa: 'Posso modificare le mie informazioni di registrazione?',
  woKeYiZhuCeDuoGeZhangHuMa: 'Posso registrare più account?',
  xiaCiShouYiShiJian: 'Prossima volta dei guadagni',
  xiaDanChengGong: 'ordinato con successo',
  xinGongNengShangXian: 'Le nuove funzionalità sono online!',
  xinMiMa: 'nuova password',
  yanShiZhangHaoBuNengShiYongGaiGongNeng:
    'Gli account demo non possono utilizzare questa funzionalità',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi:
    'I conti demo non possono utilizzare il trading intelligente',
  yanShiZhangHuYiJinYong: 'Conto demo disabilitato',
  yiDaoQi: 'essere scaduto',
  yiFenRun: "L'utile è stato diviso",
  yiFenRunTianShu: 'Numero di giorni di partecipazione agli utili',
  yiHuanKuan: 'Rimborsato',
  yiJuJue: 'respinto',
  yiQieHuanWeiXuNiZhangHu: 'Passato al conto virtuale',
  yiQieHuanWeiZhenShiZhangHu: 'Passato al conto reale',
  yiRenZheng: 'verificato',
  yiWanCheng: 'completato',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    'Alcuni siti Web possono consentire agli utenti di registrare più account, ma la maggior parte dei siti Web consente a ciascun utente di registrare un solo account. \nSe tenti di registrare più account, il tuo account potrebbe essere bannato o eliminato.',
  zhangFu: 'Aumento',
  zhenFu: 'ampiezza',
  zhuCeChengGong: 'Registrazione avvenuta',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    "La registrazione di un account ti consente di utilizzare le funzionalità del Sito o dell'Applicazione in modo più conveniente e protegge le tue informazioni personali.",
  zhuCeZhangHuXuYaoShiMoXinXi: 'Quali informazioni sono necessarie per registrare un account?',
  zongLiXi: 'interesse totale',
  zuiDiJia: 'prezzo più basso',
}
